// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-sidebar {
  background: #666;
  width: 300px;
  padding-top: 72px;
  transition: all 0.3s;
}
.main-sidebar.closed {
  width: 64px;
}
.main-sidebar.closed .nav-menu__list__item__link__text {
  opacity: 0;
}

.nav-menu__list__item__link {
  padding: 16px 24px;
  display: flex;
  text-decoration: none;
  color: #fff;
  align-items: center;
}
.nav-menu__list__item__link.active {
  background: #333;
  box-shadow: inset 5px 0 0 0 #0abf53;
}
.nav-menu__list__item__link:hover {
  background: #555;
}
.nav-menu__list__item__link__icon {
  padding-right: 16px;
}
.nav-menu__list__item__link__text {
  transition: all 0.3s;
}`, "",{"version":3,"sources":["webpack://./src/components/Menu/Menu.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;AADF;AAGE;EACE,WAAA;AADJ;AAEI;EACE,UAAA;AAAN;;AAIA;EACE,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;AADF;AAGE;EACE,gBAAA;EACA,mCAAA;AADJ;AAGE;EACE,gBAAA;AADJ;AAGE;EACE,mBAAA;AADJ;AAGE;EACE,oBAAA;AADJ","sourcesContent":["@import \"./../../utils/scss/variables\";\n\n.main-sidebar {\n  background: #666;\n  width: 300px;\n  padding-top: 72px;\n  transition: all 0.3s;\n\n  &.closed {\n    width: 64px;\n    .nav-menu__list__item__link__text {\n      opacity: 0;\n    }\n  }\n}\n.nav-menu__list__item__link {\n  padding: 16px 24px;\n  display: flex;\n  text-decoration: none;\n  color: #fff;\n  align-items: center;\n\n  &.active {\n    background: #333;\n    box-shadow: inset 5px 0 0 0 $primary-color;\n  }\n  &:hover {\n    background: #555;\n  }\n  &__icon {\n    padding-right: 16px;\n  }\n  &__text {\n    transition: all 0.3s;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
